export const ASYNC_EXPORT_JOBS_STORE_NAME = 'HeyLibbyAsyncExportJobs'

export const EXPORT_POLL_INTERVAL_MS = 3_000

/** Matches S3 lifecycle expiry on CRM/reporting export buckets (replifyCRM CDK: 7 days). */
export const EXPORT_FILE_RETENTION_MS = 7 * 24 * 60 * 60 * 1_000

/** @deprecated Use EXPORT_FILE_RETENTION_MS */
export const EXPORT_STALE_JOB_MS = EXPORT_FILE_RETENTION_MS

/**
 * How long an in-progress job is allowed to block starting another one.
 *
 * Mirrors `DEFAULT_STALE_PROCESSING_MS` in replifyCRM
 * `packages/export/src/backgroundRunner.ts` (30 min), the point at which the
 * server gives up on a PROCESSING job and reports it FAILED. Past that the job
 * is presumed dead — its task crashed or was redeployed, which also freed the
 * server's export slot — so it must stop gating the button, otherwise a crashed
 * export would lock the user out until the status endpoint caught up.
 */
export const EXPORT_BLOCKING_MAX_AGE_MS = 30 * 60 * 1_000
